module.exports = __webpack_public_path__ + "static/img/28-2.868a6f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/28-2.jpg
// module id = dig1
// module chunks = 0